export default __webpack_public_path__ + "static/media/minus.7a9701d2.svg";